const config = {
	mediaCDN: `${
		window.PERFORMYARD_MEDIA_CDN ? window.PERFORMYARD_MEDIA_CDN : "https://performyard-content.performyard.com/"
	}`,
	change: true,
};

export default config;
